var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInfoButton = function SvgInfoButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0a10 10 0 1 0 10 10A10 10 0 0 0 10 0Z",
    fill: "#59b0e1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M11.529 15.46a1.524 1.524 0 0 1-3.049 0V8.818a1.524 1.524 0 0 1 3.049 0ZM10 6.046a1.674 1.674 0 1 1 1.675-1.675A1.675 1.675 0 0 1 10 6.046Z",
    fill: "#fff"
  })));
};
export default SvgInfoButton;